module.exports = __webpack_public_path__ + "dc1d984177ab5be25ab654adeb02dcd1.svg";